<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { ref } from 'vue'

const { t } = useI18n()
const router = useRouter()

const cosigner = ref(false)

function goHome() {
  router.push('/')
}
</script>

<template>
  <v-container>
    <v-row justify="center">
      <v-col>
        <h1 class="heading">
          {{ t('lan_umsokn_step9_header') }}
        </h1>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col md="7">
        <p>{{ t('lan_umsokn_step9_text_body') }}</p>
        <p v-if="cosigner" class="cosigner-text">
          {{ t('umsokn_final_step_comment') }}
        </p>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col md="7" class="center__content router__btn">
        <button class="btn btn-default" @click="goHome">
          {{ t('lan_umsokn_step9_forsida') }}
        </button>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
h1 {
  color: #194458;
  font-size: 55px;
  font-weight: 900;
  line-height: 75px;
  text-align: center;
}

p {
  color: #194458;
  font-size: 21px;
  line-height: 34px;
  text-align: center;
  margin-bottom: 40px;
}

.cosigner-text {
  font-size: 16px;
}

.center__content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.router__btn > button {
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  line-height: 27px;
  border-radius: 4px;
  background: linear-gradient(180deg, #00BCB3 0%, #00877C 100%);
  height: 60px;
  width: 173px;
  border: none;
}
</style>
